import { render, staticRenderFns } from "./LearnHabitat.vue?vue&type=template&id=1b5d61f0&scoped=true&"
import script from "./LearnHabitat.vue?vue&type=script&lang=js&"
export * from "./LearnHabitat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d61f0",
  null
  
)

export default component.exports